import { service, authStore, premiumStore, Premium, initPolicyHolderInfo, ApplicationInfo } from '.'
import { tapPayTCMsgStatusCode } from 'mobileApp/common/component/tapPay'

export interface LaptopInfo { imei: string, subjectId: number | '', poProductNo: string, supNo: string, mara: string, model: string, sellPrice: number | '', mbInvoiceNum: string, importSource: string }
const initLaptopInfo: LaptopInfo = { imei: '', subjectId: '', poProductNo: '', supNo: '', mara: '', model: '', sellPrice: '', mbInvoiceNum: '', importSource: '' }
export const ltcProductCategory = 'laptop'

class LtcStore {
  navi = { goBack: () => { }, goNext: () => { } }

  private _cfSignature: any
  private _tmSignature: any
  private _phSignature: any
  private _smSignature: any
  private _chSignature: any
  laptopInfo = initLaptopInfo
  policyHolderInfo = initPolicyHolderInfo
  app: any
  finalApp: any
  private _payment = {
    options: [] as Premium[],
    type: 'M',
    isSuccessful: false,
  }

  emptyData = () => {
    this._cfSignature = undefined
    this._tmSignature = undefined
    this._phSignature = undefined
    this._smSignature = undefined
    this._chSignature = undefined
    this.laptopInfo = initLaptopInfo
    this.policyHolderInfo = initPolicyHolderInfo
    this.app = undefined
    this.finalApp = undefined
    this._payment = {
      options: [],
      type: 'M',
      isSuccessful: false,
    }
  }

  get cfSignature() { return this._cfSignature }
  get tmSignature() { return this._tmSignature }
  get phSignature() { return this._phSignature }
  get smSignature() { return this._smSignature }
  get chSignature() { return this._chSignature }

  get paymentOptions() { return this._payment.options }
  get currentOption() { return this._payment.options.filter(option => option.paymentType === this._payment.type)[0] }
  get productType() { return this.currentOption.productType }
  get paymentType() { return this._payment.type }
  get paymentTypeDesc() { return this._payment.type === 'M' ? '月繳' : this._payment.type === '1Y' ? '年繳（一年期）' : this._payment.type === '2Y' ? '年繳（二年期）' : this._payment.type === '3Y' ? '年繳（三年期）' : '' }
  get isPaymentSuccessful() { return this._payment.isSuccessful }

  set paymentType(type) { this._payment.type = type }

  initCase = async () => {
    const res = await service.getNewToken()
    if (res.status === 200) {
      // get new token
      const newToken: string = (await res.json()).token
      // update new token
      authStore.updateToken = newToken

      // reset data
      this._cfSignature = undefined
      this._tmSignature = undefined
      this._phSignature = undefined
      this._smSignature = undefined
      this._chSignature = undefined
      this.laptopInfo = initLaptopInfo
      this.policyHolderInfo = initPolicyHolderInfo
      this.app = undefined
      this.finalApp = undefined
      this._payment = {
        options: [],
        type: 'M',
        isSuccessful: false,
      }

      return Promise.resolve()
    }
    const body = await res.json()
    const msg = body?.detail ?? body?.message
    return Promise.reject(`${msg}, ${res.status}`)
  }

  quote = () => {
    if (this.laptopInfo.sellPrice === '') return Promise.reject({ message: '空機售價不可以空白！' })
    const matchedPremiums = premiumStore.getPremiumsByProductCategoryAndPrice(ltcProductCategory, this.laptopInfo.sellPrice, this.laptopInfo.supNo)
    this._payment.options = matchedPremiums
    return Promise.resolve()
  }

  getApplicationInfo = () => {
    const { 
      name: phName, identity: phNationId, birthday: phBirthday, city: phCity, district: phDistrict, address: phAddress, nationType: phNationType, nationName: phNationName, 
      email: phEmail, phoneNo: phPhone, profession: phProfession, purpose: phPurpose, phAttribute, poProductNo, phSaleSalaryNo } = this.policyHolderInfo
    const { subjectId, imei: mbImei, sellPrice, mbInvoiceNum, importSource: subjectSource } = this.laptopInfo
    const poPayType = this.paymentType
    const poProductType = this.productType

    const application: ApplicationInfo = {
      phName, phNationId, phBirthday,
      phCity, phDistrict, phAddress, phNationType, phNationName,
      phEmail, phPhone, phProfession, phPurpose, phAttribute,
      mbId: Number(subjectId), mbImei, mbSellPrice: Number(sellPrice), poPayType, poProductNo, poProductType,
      phSaleSalaryNo, mbInvoiceNum, subjectSource, productCategory: ltcProductCategory
    }

    return application
  }

  getApp = async () => {
    if (this.laptopInfo.sellPrice === '') return Promise.reject({ message: '空機售價不可以空白！' })

    const res = await service.uploadApp(this.getApplicationInfo(), ltcProductCategory)

    if (res.status === 200) {
      const res = await service.getAppImg()
      if (res.status === 200) {
        this.app = window.URL.createObjectURL(await res.blob())
        return Promise.resolve()
      } else {
        const body = await res.json()
        const msg = body?.detail ?? body?.message
        throw new Error(`${msg}, ${res.status}`)
      }
    } else {
      const body = await res.json()
      const msg = body?.detail ?? body?.message
      throw new Error(`${msg}, ${res.status}`)
    }
  }

  getFinalApp = async () => {
    if (this.laptopInfo.sellPrice === '') return Promise.reject({ message: '空機售價不可以空白！' })

    const res = await service.uploadFinalApp(this.getApplicationInfo())

    if (res.status === 200) {
      const res = await service.getAppImg()
      if (res.status === 200) {
        this.finalApp = window.URL.createObjectURL(await res.blob())
        return Promise.resolve()
      } else {
        const body = await res.json()
        const msg = body?.detail ?? body?.message
        throw new Error(`${msg}, ${res.status}`)
      }
    } else {
      const body = await res.json()
      const msg = body?.detail ?? body?.message
      throw new Error(`${msg}, ${res.status}`)
    }
  }

  uploadCfSignature = async (signature: any) => {
    this._cfSignature = signature
    const res = await service.uploadCfSignature(signature)
    return res.status
  }

  uploadTmSignature = async (signature: any) => {
    this._tmSignature = signature
    const res = await service.uploadTmSignature(signature)
    return res.status
  }

  uploadPhSignature = async (signature: any) => {
    this._phSignature = signature
    const res = await service.uploadPhSignature(signature)
    return res.status
  }

  uploadSmSignature = async (signature: any) => {
    this._smSignature = signature
    const res = await service.uploadSmSignature(signature)
    return res.status
  }

  uploadChSignature = async (signature: any) => {
    this._chSignature = signature
    const res = await service.uploadChSignature(signature)
    return res.status
  }

  payByPrime = async (prime: string, payName: string, payRelation: string) => {
    const res = await service.payByPrime(prime, payName, payRelation)

    if (res.status === 200) {
      this._payment.isSuccessful = true
      return Promise.resolve()
    } else if (res.status === 424) {
      const body = await res.json()
      const msg = body?.detail ?? body?.message
      const msgStatusCode = msg?.split(' ')[0]
      throw new Error(`${tapPayTCMsgStatusCode.get(msgStatusCode) ?? msg}, ${res.status}`)
    } else {
      const body = await res.json()
      const msg = body?.detail ?? body?.message
      throw new Error(`${msg}, ${res.status}`)
    }
  }
}

export const ltcStore = new LtcStore()

